import { authFetch } from "../App";

export const getData = (url) => {
  return authFetch(url).then((response) => (response && response.status == 200 ? response.json() : []));
};

export const postData = (url = "", data = {}) => {
  return authFetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => console.error(`Error posting to ${url}. Error: ${error}`));
};



// WEBPACK FOOTER //
// ./src/api/api.js